import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { api, setToken } from '../../api/client';
import { executeRecaptchaEnterprise } from '../../utils/recaptchaEnterprise';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';
import './Admin.css';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    let recaptchaToken = null;
    try {
      recaptchaToken = await executeRecaptchaEnterprise('ADMIN_LOGIN');
    } catch (recaptchaErr) {
      setError(recaptchaErr.message || 'Security check failed to load.');
      setLoading(false);
      return;
    }
    try {
      const data = await api('/api/admin/login', {
        method: 'POST',
        body: JSON.stringify({ email, password, recaptchaToken }),
      });
      setToken(data.token);
      navigate('/admin/dashboard', { replace: true });
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="admin-login admin-login-vuexy">
      <Box className="admin-login-left" />
      <Box className="admin-login-right">
        <Typography variant="h5" className="admin-login-logo" sx={{ fontWeight: 600 }}>
          Gem Fashion Admin
        </Typography>
        <Box className="admin-login-form-wrap">
          <Typography variant="h4" sx={{ fontWeight: 600, mb: 0.5 }}>
            Welcome! 👋
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 3 }}>
            Sign in with your admin account
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate className="admin-login-form">
            {error && (
              <Typography color="error" sx={{ mb: 2, fontSize: '0.875rem' }}>
                {error}
              </Typography>
            )}
            <TextField
              id="admin-email"
              label="Email"
              type="email"
              fullWidth
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{ mb: 2 }}
              variant="outlined"
            />
            <TextField
              id="admin-password"
              label="Password"
              type={showPassword ? 'text' : 'password'}
              fullWidth
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{ mb: 2 }}
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword((s) => !s)}
                      onMouseDown={(e) => e.preventDefault()}
                      edge="end"
                    >
                      {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={loading}
              sx={{ mt: 1, py: 1.5, textTransform: 'none', fontWeight: 600 }}
            >
              {loading ? 'Signing in…' : 'Sign in'}
            </Button>
            <Typography sx={{ mt: 2, textAlign: 'center' }}>
              <Link to="/admin/forgot-password" style={{ fontSize: '0.875rem' }}>
                Forgot password?
              </Link>
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
